package songwritersnotebook.app.utils

actual class RemoteConfigManager actual constructor() {
    actual suspend fun fetchAndActivate() {
        // Will implement native JS remote config later
    }

    actual fun getBoolean(key: String): Boolean {
        return false
    }
}
